import React from 'react';
import {useFormik, FormikContext} from "formik";
import { useDispatch, useSelector } from 'react-redux';
import {setGetViewBonuses} from '../../store/thunk/setGetViewBonuses';
import {setPostUpdateBonuses} from '../../store/thunk/setPostUpdateBonuses';
import BreadCrumbs from '../breadCrumbs';
import BlockButton from '../block-button';
import {useStyles} from './helpers';
import BlockSumBonus from '../block-sum-bonus';
import BlockAutoCloseBonus from '../block-autoclose-bonus';
import BlockPossibleBonus from '../block-possible-bonus';
import BlockGeneral from '../block-general';
import DialogSuccess from '../dialog-success';
import DialogErrors from '../dialog-errors';
import BlockFreespin from '../block-freespin';

const BonusRegistration = ({id}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetViewBonuses({id}));
    }, [id])

    const [openModal, setOpenModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);

    const onSubmit = (store) => {
        dispatch(setPostUpdateBonuses(store, setOpenModal, setErrorModal))
    }

    const initialValues = useSelector(state => state.bonuses.view);
    const enableReinitialize = true;
    const formik = useFormik({onSubmit, initialValues, enableReinitialize});

    return (
        <div className={classes.root}>
            <BreadCrumbs label={initialValues.label}/>
            <FormikContext.Provider value={formik}>
                <form onSubmit={formik.handleSubmit} className={classes.root} >
                    <BlockButton submit={formik.submitForm}/>
                    <div>
                        <BlockGeneral formik={formik}/>
                        <BlockSumBonus formik={formik}/>
                        <BlockFreespin formik={formik}/>
                        {/* <BlockSettingsWagering formik={formik} /> */}
                        <BlockAutoCloseBonus formik={formik} />
                        <BlockPossibleBonus formik={formik} />
                    </div>
                </form>
            </FormikContext.Provider>
            <DialogSuccess setOpenModal={setOpenModal} openModal={openModal}/>
            <DialogErrors setOpenModal={setErrorModal} openModal={errorModal} />
        </div>
    )
}

export default BonusRegistration;